import React from 'react';
import { graphql } from 'gatsby';

import { useLocalization } from '@plugins/keytrade-localization/useLocalization';
import Badge from '@/components/Badge';

export type ArticleTagType = {
  text?: string;
  url?: string;
};

type Props = ArticleTagType;

const ArticleTag: React.FC<Props> = ({ text, url }) => {
  const { navigate } = useLocalization();
  const onTagClick = (): void => {
    navigate(url);
  };
  if (url)
    return (
      <Badge
        title={text}
        onClick={onTagClick}
        size='sm'
        type={'light'}
        margin={'0 .5rem 0 0'}
      />
    );
  else
    return (
      <Badge title={text} size='sm' type={'light'} margin={'0 .5rem 0 0'} />
    );
};

export default ArticleTag;
export const articleTagQuery = graphql`
  fragment ArticleTagFragment on ContentfulArticleTag {
    text
  }
`;
